// src/components/DesktopNav.js
// Barre de navigation persistante pour le desktop (>= 1024px).
// Sur mobile/tablette, la navigation reste la BottomNav / le header de la carte.
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./DesktopNav.css";

const ITEMS = [
    { key: "home", path: "/", label: "nav.map" },
    { key: "community", path: "/community", label: "nav.community" },
    { key: "dives", path: "/dives", label: "nav.dives" },
    { key: "profile", path: "/profile", label: "nav.profile" },
];

const isActive = (path, pathname) =>
    path === "/" ? pathname === "/" : pathname.startsWith(path);

export default function DesktopNav({ onLogout }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { t, i18n } = useTranslation();
    const lang = i18n.language?.substring(0, 2) || "fr";

    return (
        <nav className="desktop-nav" aria-label="Navigation principale">
            <div className="desktop-nav-inner">
                <span className="dn-brand">Swiss Dive Agenda</span>

                <div className="dn-links">
                    {ITEMS.map((it) => {
                        const active = isActive(it.path, pathname);
                        return (
                            <button
                                key={it.key}
                                type="button"
                                className={`dn-link ${active ? "active" : ""}`}
                                aria-current={active ? "page" : undefined}
                                onClick={() => navigate(it.path)}
                            >
                                {t(it.label)}
                            </button>
                        );
                    })}
                </div>

                <div className="dn-right">
                    <button className="dn-plan" type="button" onClick={() => navigate("/?create=1")}>
                        + {t("create.button")}
                    </button>

                    <div className="dn-lang">
                        {["fr", "de", "it", "en"].map((l) => (
                            <button
                                key={l}
                                type="button"
                                className={lang === l ? "active" : ""}
                                onClick={() => i18n.changeLanguage(l)}
                            >
                                {l.toUpperCase()}
                            </button>
                        ))}
                    </div>

                    <button className="dn-icon" type="button" title={t("hamburgerMenu.about")} aria-label={t("hamburgerMenu.about")} onClick={() => navigate("/about")}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                    </button>

                    <button className="dn-icon" type="button" title={t("hamburgerMenu.logout")} aria-label={t("hamburgerMenu.logout")} onClick={onLogout}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                    </button>
                </div>
            </div>
        </nav>
    );
}
